<template>
    <el-dialog :title="title" :visible.sync="show" width="500px">
        <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="180" label="left">
            <el-form-item label="大区名称" prop="large_name">
                <el-select v-model="ruleForm.large_name" @change="selectChange(ruleForm.large_name)">
                    <el-option v-for="item in regionList" :value="item.name" :key="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="区域名称" prop="sb_name">
                <el-select v-model="ruleForm.sb_name" @change="selectAreaChange(ruleForm.sb_name)">
                    <el-option v-for="item in areaList" :value="item.sb_name" :label="item.sb_name" :key="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="点位名称" prop="point_name">
                <el-input v-model="ruleForm.point_name" :autofocus="true" placeholder="点位名称" :maxlength="30"></el-input>
            </el-form-item>
              <el-form-item label="渠道名称" prop="channel">
                   <el-select v-model="ruleForm.channel" placeholder="请选择">
                      <el-option
                        v-for="item in channelOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                   </el-select>  
            </el-form-item>
            <el-form-item prop="pid" label="省" label-width="80px">
                <el-select @change="changeProvince" placeholder="请选择" v-model="ruleForm.pid">
                    <el-option v-for="item in province_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="cid" label="市" label-width="80px">
                <el-select @change="cityChange" placeholder="请选择" v-model="ruleForm.cid">
                    <el-option v-for="item in city_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="area_code" label="区" label-width="80px">
                <el-select @change="areaChange" class="lineItem" placeholder="请选择" v-model="ruleForm.area_code">
                    <el-option v-for="item in area_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址" prop="addr_info">
                <el-input type="textarea" autosize v-model="ruleForm.addr_info" maxlength="11">
                </el-input>
            </el-form-item>
        </el-form>
                     <span slot="footer" class="dialog-footer">
                              <el-button @click="cancelshow('ruleForm')">取 消</el-button>
                              <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
                        </span>
    </el-dialog>
</template>

<script>
import { isNumber_AZ_Chinese } from "@/plugins/common";
import apis from "@/config/apis";
export default {
    data() {
        var point_name = (rule, value, callback) => {
            if (!isNumber_AZ_Chinese(value)) {
                return callback(new Error("请输入中文、字母或者数字，最大30个字符"));
            } else {
                return callback();
            }
        };
        return {
            show: false,
            title: '',
            province_options: [],
            city_options: [],
            area_options: [],
            regionList: [],
            areaList: [],
            channel:'',
            channelOptions:[{
                value: 'channel1',
                label: '渠道1'
              },
            {
                value: 'channel2',
                label: '渠道2'
            },
             {
                value: 'channel3',
                label: '渠道3'
            }],
            pids: '',
            ruleForm: {
                number: "",
                line_id: "",
                create_at: "",
                pid: "",
                cid: "",
                area_code: "",
                name: "",
                line: "",
                type: "",
                status: "",
                addr_code: "",
                addr_info: "",
                point_name: "",
                point_type: "",
                large_name: "",
                region: "",
                name: "",
                sb_name: "",
                region_id: "",
                large_area_id: "",
                id: "",
                channel:""
            },
            rules: {

                large_name: [{
                    required: true,
                    message: "请选择大区",
                    trigger: "change"
                }],
                sb_name: [{
                    required: true,
                    message: "请选择区域",
                    trigger: "change"
                }],
                point_name: [{
                    required: true,
                    validator: point_name,
                    trigger: "change"
                }],
               pid: [{
                    required: true,
                    message: "请选择省",
                    trigger: "change"
                }],
                cid: [{
                    required: true,
                    message: "请选择市",
                    trigger: "change"
                }],
                area_code: [{
                    required: true,
                    message: "请选择区",
                    trigger: "change"
                }],
                 addr_info: [{
                    required: true,
                    message: "请输入具体位置",
                    trigger: "change"
                }],
                  channel: [{
                    required: true,
                    message: "请选择渠道",
                    trigger: "change"
                }],
            }
        };
    },
    props: {},
    created() { this.getbizRegion(), this.getlprovice() },
    methods: {
        getbizRegion() {
            this.$axios.get(apis.region).then(res => {
                if (res.data.code == 200) {
                    this.regionList = res.data.data;
                }
            })
        },
        selectChange(val) {
            this.regionList.forEach((item, index) => {
                if (item.name == val) {
                    this.ruleForm.large_name = item.name;
                    this.ruleForm.large_area_id = item.id;
                    this.ruleForm.sb_name='';
                    this.ruleForm.point_name = '';
                    this.searchAreaData();
                }
            });
            this.ruleForm.area_name = "";
        },
        //获取省信息
        getlprovice() {
            this.$axios.get(apis.getProvice).then(data => {
                let datas = data.data;
                if (datas.code == 200) {
                    this.province_options = datas.data;
                }
            });
        },
        //选择省
        changeProvince(event, item) {
            this.pids = event;
            this.ruleForm.cid = "";
            this.ruleForm.area_code = "";
            this.getCity("province");
        },
        //选择市
        selectAreaChange(val) {
            this.ruleForm.sb_name = val;
            this.searchAreaData();
        },
        //选择区
        searchAreaData() {
            let params = {
                rid: this.ruleForm.large_area_id
            }
            this.$axios.get(apis.area, { params }).then(res => {
                if (res.data.code == 200) {
                    this.areaList = res.data.data;
                    this.areaList.filter((item, index) => {
                        if (item.sb_name === this.ruleForm.sb_name) {
                            this.ruleForm.region_id = item.id;
                        }
                    })
                }
            })
        },

        modifyshow(row) {
            this.show = true;
            this.title = '修改点位';
            this.ruleForm.id = row.id;
            this.getPoint();
        },
        getPoint() {
            this.$axios.get(apis.pointdetail + this.ruleForm.id).then(res => {
                let datas = res.data.data;
                let { pid, cid, city, region, rid, sub_region, point_name, addr_code, id, addr_info,channel } = datas;
                this.ruleForm = {
                    pid: pid,
                    cid: cid,
                    area_code: city,
                    large_name: region,
                    large_area_id: rid,
                    sb_name: sub_region,
                    point_name: point_name,
                    area_code: addr_code,
                    addr_info: addr_info,
                    id: id,
                    channel:channel

                }
                this.getCity('province');
                this.getAreas();
                this.searchAreaData();
            })
        },

        /*市选择*/
        cityChange(event, item) {
            this.ruleForm.area_code = "";
            this.cids = event;
            this.getArea();
        },
        areaChange() {
            this.getAreas();
        },
        /*区选择*/
        getArea() {
            let jsondata = {
                cid: this.ruleForm.cid
            };
            this.$axios.post(apis.getArea, jsondata).then(data => {
                let datas = data.data;
                if (datas.code === 200) {
                    this.area_options = datas.data;
                }
            });
        },

        /*请求市*/
        getCity(type = "default") {
            let jsondata = {
                pid: this.ruleForm.pid
            };
            this.$axios.post(apis.getCity, jsondata).then(data => {
                let datas = data.data;
                if (datas.code === 200) {
                    if (type === "default") {
                        this.province_options = datas.data;
                        this.city_options = [];
                    }
                    if (type === "province") {
                        this.city_options = datas.data;
                        this.area_options = [];
                    } else if (type === "city") {
                        this.area_options = datas.data;
                    }
                }
            });
        },

        getAreas() {
            let jsondata = {
                cid: this.ruleForm.cid
            };
            this.$axios.post(apis.getArea, jsondata).then(data => {
                let datas = data.data;
                if (datas.code == 200) {
                    this.area_options = datas.data;
                }
            })
        },
        addshow(row, ruleForm) {
                
            this.ruleForm.id ='';
            this.ruleForm.large_name ='';
            this.ruleForm.sb_name = "";
            this.ruleForm.point_name = '';
            this.ruleForm.channel = '';
            this.ruleForm.pid = '';
            this.ruleForm.cid = '';
            this.ruleForm.area_code = '';
            this.ruleForm.addr_info = '';
            this.show = true;
             this.$refs.ruleForm.resetFields();
            this.getlprovice();
            this.title = '新增点位';
        },
        cancelshow(ruleForm) {
            this.$refs[ruleForm].resetFields();
            this.show = false;
        },
        confirm(ruleForm) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.title == '修改点位') {
                        let jsonData = {
                            id: this.ruleForm.id,
                            point_name: this.ruleForm.point_name,
                            sub_region_id: this.ruleForm.region_id,
                            addr_code: this.ruleForm.area_code,
                            addr_info: this.ruleForm.addr_info,
                            channel:this.ruleForm.channel
                        };
                        this.$axios.put(apis.updatepoint, jsonData).then(res => {
                            if (res.data.code === 200) {
                                this.ruleForm.id == '';
                                this.$emit("emitConfirm");
                                 this.$message({
                                  message: '修改成功',
                                  type: 'success'
                                 });
                                this.$refs.ruleForm.resetFields();
                                this.show = false;
                            } else {
                                this.show = true;
                                 this.$message({
                                  message: res.data.msg,
                                  type: 'error'
                                 });
                            }
                        });
                    } else {
                        let jsonData = {
                            point_name: this.ruleForm.point_name,
                            sub_region_id: this.ruleForm.region_id,
                            addr_code: this.ruleForm.area_code,
                            addr_info: this.ruleForm.addr_info,
                            channel:this.ruleForm.channel
                        }
                        this.$axios.post(apis.addpoint, jsonData).then(res => {
                            if (res.data.code === 200) {
                                this.$emit("emitConfirm")
                                this.show = false;
                                 this.$message({
                                  message: '新增成功',
                                  type: 'success'
                                 });
                                this.$refs.ruleForm.resetFields();
                            } else {
                               this.$message({
                                  message: res.data.msg,
                                  type: 'error'
                                 });
                            }
                        })
                    }
                }
            });
        },
    },
    watch: {}
};
</script>


<style lang="scss" scoped>

.el-input {
    width: 250px;
}

.el-select {
    width: 250px;
}

.el-textarea {
    width: 250px;
}

.el-form--inline .el-form-item__label {
    width: 100px;
}
</style>
